import styled from 'styled-components';

import StationSelectField from 'components/ui/StationSelectField';
import Button from 'components/ui/Button';

export const StyledStationSelect = styled(StationSelectField)`
  margin-bottom: 15px;
`;

export const StyledHeading = styled.h1`
  margin-top: 0px;
`;

export const StyledBookingMagnet = styled.div`
  display: flex;
  box-sizing: border-box;
  justify-content: space-between;
`;

export const StyledJourneySelect = styled.div`
  width: 400px;
`;

export const StyledSwapButton = styled(Button)`
  margin-right: 8px;
`;
